export enum NotificationStatusEnum {
    DISABLED = 'Inativo',
    ENABLED = 'Ativo',
    RUNNING = 'Em progresso',
    FINISHED = 'Finalizado',
}

export type NotificationStatus = 'DISABLED' | 'ENABLED' | 'RUNNING' | 'FINISHED';
